const ENDPOINT = process.env.REACT_APP_CSRF;

export default function csrf() {
  return fetch(ENDPOINT, { credentials: 'include' });
}
